import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = 0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpi.removeFile, {
        id,
    }, options);
    if (error) return { error, status };
    return content || {};
};
